// noinspection JSUnresolvedVariable

import {default as axioslib} from "axios";
import 'axios-retry';
import aes from 'crypto-js/aes'
import encUtf8 from 'crypto-js/enc-utf8'

function isEmptyValues(value) {
	return value === undefined
		|| value === null
		|| (typeof value === 'object' && Object.keys(value).length === 0)
		|| (typeof value === 'string' && value.trim().length === 0);
}

export const arrayHelper = {
	search(columns, query, item) {
		query = query.toLowerCase();
		let res = false;

		for (let column of columns) {
			let value = item[column];
			if (res === true || isEmptyValues(value)) {
				continue;
			}

			value = value.toString().toLowerCase();
			if (value.includes(query)) {
				res = true;
				break;
			}
		}

		return res;
	}
};

export const axios = {
	config(headers = {}, onUploadProgress = () => {
	}) {
		return {
			transformResponse: [
				(data, headers) => {
					let contentType = headers['content-type'];
					if (contentType !== undefined && contentType.includes('application/encrypted')) {
						let key = encUtf8.parse('~s74ql4rjxQ"s*bZ^.,0#k9U8phwZSfE');
						let iv = encUtf8.parse(data.slice(0, 16));
						data = aes.decrypt(data.slice(16), key, {iv: iv}).toString(encUtf8);
					}

					let ret = data;

					if (contentType.includes('application/encrypted') || contentType.includes('application/json')) {
						ret = JSON.parse(data);
					}

					if ('redirect' in ret && Object.keys(ret).length === 1) {
						window.location = ret.redirect;
					}

					return ret;
				}
			],
			headers: {...{"X-Requested-With": "XMLHttpRequest"}, ...headers},
			onUploadProgress: onUploadProgress
		};
	},
	data(objParams) {
		return new URLSearchParams(objParams).toString()
	},
	fetchPost(link, data, showError = true) {
		return new Promise(async (resolve, reject) => {

			try {
				let response = await axioslib.post(link, axios.data(data), axios.config());

				if (response.status === 200) {
					if (response.data.error === true && showError) {
						alert(response.data.result);
					} else {
						resolve(response.data.result);
					}
				}
			} catch (e) {
				console.log(e);
				reject(e);
			}
		});
	}
};

